import { SharedService } from './../../utils/shared.service';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import * as CommonConstants from '../../utils/common.constants';
import { DepartmentModel } from './department.model';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from '../master.service';
@Component({
  selector: 'app-add-department',
  templateUrl: './add-department.component.html',
  styleUrls: ['./add-department.component.scss']
})
export class AddDepartmentComponent implements OnInit {

  department: DepartmentModel = new DepartmentModel();
  departmentList: DepartmentModel[] = [];
  //orgsmDepartmentList: DepartmentModel[]=[];
  @Input() partnerId: number;
  @Input() partnerType: number;
  submitted = false;
  departmentForm: FormGroup;
  columnDefs:any[];
  specialities=[];
  assetTypes=[];
  toggleDiv = true;

  constructor(private masterService:MasterService,private http: HttpClient, config: NgbModalConfig, private modalService: NgbModal, 
    private formBuilder: FormBuilder, private sharedService: SharedService, private toastrService:ToastrService) {
    this.getDeptFormGroup();
    config.backdrop = 'static';
    config.keyboard = false;

    this.columnDefs = [
      { headerName: 'Address', field: 'addreVaLine1' },
      { headerName: 'Address Type', field: 'addressType'},
      { headerName: 'Country', field: 'countryName' },
      { headerName: 'town', field: 'townName'}       
    ];

  }

  ngOnInit() {
   this.loadmasterData();
   this.department["staRecCode"]=true;
  }
  loadmasterData(){
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
    let searchCriteria={
      masterShName:'ASSETTYPE',
      master:{}
    }
    this.masterService.searchMaster(searchCriteria).subscribe(response => {
      this.assetTypes = response['result'];
    })
  }
  
  /**
  * Declare form group
  *  
  */
  private getDeptFormGroup() {
    this.departmentForm = this.formBuilder.group({
      'deptmNameEn': ['', Validators.required],
      'assetType': new FormControl(),
      'assetSize': new FormControl(),
      'speciality': new FormControl(),
      'address': new FormControl(),
      'staRecCode': [true]      
      //'deptmNuNumberBed': new FormControl(),
      //'deptmNuNumberSpeciality': new FormControl()
    })
  }

  get f() { return this.departmentForm.controls; }

  departmentAddModal(addDepartment) {
    this.submitted = false;
    this.department = new DepartmentModel();
    this.department["staRecCode"]=true;
    this.modalService.open(addDepartment, { size: 'lg', container: '.page-content' });
  }

  onDepartmentRowSelect(department, addDepartment) {
    this.modalService.open(addDepartment, { size: 'lg', container: '.page-content' });
    this.department =  JSON.parse(JSON.stringify(department.data));
    this.department["staRecCode"]=this.department["staRecCode"] ==='A' ? true : false;
  }

  saveDepartment() {
    this.submitted = true;
    if (this.departmentForm.invalid) {
      return;
    }
    this.department.partnerId = this.partnerId;
    this.department.partnerType = this.partnerType;
    this.department["staRecCode"]=this.department["staRecCode"] ? 'A' :'I';
    this.http.post(CommonConstants.SAVE_DEPARTMENT, this.department)
      .subscribe(response => {
        if (response['code'] == 0) {
          this.toastrService.success(response['message'], 'Success');
          this.department.deptmId = response['result'];
          this.departmentList = this.sharedService.updateDuplicateRecord(this.department.deptmId, this.departmentList, "deptmId", this.department);
          this.sharedService.setOrganismDepartment(this.departmentList );
          this.modalService.dismissAll();
        } else {
          this.toastrService.error(response['message'], 'Error');
        }

      });
  }

  toggleContent(){
    this.toggleDiv = !this.toggleDiv;
  }

}
